import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'redux/store';
import { Table, Title } from 'components';
import { Card, Col, Row, Badge } from 'react-bootstrap';
import { getAccountsTableAdmin } from 'redux/slices/Accounts';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { getStoreGroupsTable } from 'redux/slices/StoreGroups';
import { getAccessFromEnum, UserAccess } from 'models/freedomModels/enums/userAccess';
import { createSingleSelectFilter, Filter, FilterState } from 'components/AgGrid/FilterComponents/Filters';
import { Column } from 'react-table';

export function Users() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const users = useAppSelector((state: RootState) => state.account);
	const storeGroups = useAppSelector((state: RootState) => state.storeGroups);
	const [filterState, setFilterState] = useState<FilterState>();	

	const columnsb: Column[] = [
		{
			Header: 'ID',
			accessor: 'id',
			defaultCanSort: true,
			width: 30,
			Cell: (row: any) => <Link to={`/support/user/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: 'Given Name',
			accessor: 'givenName',
			defaultCanSort: true,
			Cell: (row: any) => <Link to={`/support/user/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: 'Family Name',
			accessor: 'familyName',
			defaultCanSort: true,
			Cell: (row: any) => <Link to={`/support/user/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: 'Email',
			accessor: 'email',
			defaultCanSort: true,
			Cell: (row: any) => <Link to={`/support/user/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: "comments",
			accessor: "comments",
			defaultCanSort: true,
			width: 1200,
			Cell: (row: any) => <Link to={`/support/user/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: 'Store Group',
			accessor: 'storeGroupId',
			defaultCanSort: true,
			Cell: (row: any) => <Link to={`/support/user/${row.cell.row.original.id}`}>{storeGroups.table.find(sg => sg.id === row.value)?.name ?? ""}</Link>,
		},
		{
			Header: 'Products',
			accessor: 'products',
			defaultCanSort: true,
			sortType: (rowA: any, rowB: any) => rowA.original.access - rowB.original.access,
			Cell: (row: any) => { 
				return (
					<div className="d-inline-flex gap-1">
						{(row.cell.row.original.access & UserAccess.ZFreedom) > 0 && <Badge className="me-1 badge-info">Z Freedom</Badge>}
						{(row.cell.row.original.access & UserAccess.ZPocket) > 0 && <Badge className="me-1 badge-success">Z Pocket</Badge>}
					</div>
				);
			}
		},
		{
			Header: 'Status',
			accessor: 'status',
			defaultCanSort: true,
			sortType: (rowA: any, rowB: any) => ((rowA.original.status === "Active") as unknown as number) - ((rowB.original.status === "Active") as unknown as number),
			Cell: (row: any) => {
				return (
					<>
						{row.cell.row.original.status === "Suspended" && <Badge className="me-1 badge-outline-danger">Suspended</Badge>}
						{row.cell.row.original.status === "Active" && <Badge className="me-1 badge-outline-primary">Active</Badge>}
					</>
				);
			}
		},
	];
	
	useEffect(() => {
		dispatch(getStoreGroupsTable());
		dispatch(getAccountsTableAdmin());
	}, []);

	const filteredTable = useMemo(() => {
		const filteredAccessUsers =  users.table
			.filter((user: any) => {
				if (filterState) {
					const accessList = getAccessFromEnum(user.access);
					let match = false;
					const freedomFilterPassed = (filterState.zFreedomFilter === undefined || (filterState.zFreedomFilter === (accessList.find(a => a === UserAccess.ZFreedom) != null)));
					const pocketFilterPassed = (filterState.zPocketFilter === undefined || (filterState.zPocketFilter === (accessList.find(a => a === UserAccess.ZPocket) != null)));
					if (freedomFilterPassed && pocketFilterPassed) {
						match = true;
					}
					return match;
				} else {
					return true;
				}
			});
	
			return filteredAccessUsers;	
	}, [filterState, users.table]);

	return (
		<>
			<Title pageTitle="Users" parent="Support" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<div className="page-container">
									<Table										
										columns={columnsb}
										data={filteredTable}
										pageSize={15}
										isSortable={true}
										pagination={true}
										isSelectable={true}
										isSearchable={true}
										reloadTableRows={() => dispatch(getAccountsTableAdmin())}
										addNewRow={() => navigate("/support/user/new")}										
										filterComponent={
											<Filter 
												onFilterApplied={(f: FilterState) => {
													setFilterState(f);
												}}
												filters={[
													createSingleSelectFilter({
														options: [true, false],
														display: (option) => { return option === null ? "" : option === true ? "Yes" : "No" },
														value: (option) => option,
														hasNoneOption: true,
														label: 'Z Freedom',
														filterName: "zFreedomFilter"
													}),
													createSingleSelectFilter({
														options: [true, false],
														display: (option) => { return option === null ? "" : option === true ? "Yes" : "No" },
														value: (option) => option,
														hasNoneOption: true,
														label: 'Z Pocket',
														filterName: "zPocketFilter"
													})
												]} 
											/>
										}
									/>
								</div>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
}